import React, { MouseEvent, useRef, useState } from 'react';
import classNames from 'classnames';

import { useOutsideClick } from 'src/hooks';
import { BillingCodesInfoPopover } from 'src/components/Clients/BillingCodesInfoPopover';

import { ReactComponent as IconQuestion } from '../../assets/svgs/icon-question.svg';

export enum BillingCodesInfoBubbleTestID {
  QuestionIconButton = 'question-icon-button',
  InfoPopover = 'info-popover',
}

export interface Props {
  dataTestID?: string;
  warning?: boolean;
}

export const BillingCodesInfoBubble: React.FC<Props> = ({ dataTestID, warning = false }) => {
  const [showPopover, setShowPopover] = useState(false);

  const popoverRef = useRef<HTMLDivElement>(null);
  const questionBubbleRef = useRef<HTMLDivElement>(null);

  useOutsideClick(popoverRef, (e: MouseEvent) => {
    if (!questionBubbleRef) {
      return;
    }
    if (!questionBubbleRef.current?.contains(e.currentTarget)) {
      setShowPopover(false);
    }
  });

  return (
    <div
      className="inline-block overflow-visible relative ml-1"
      ref={questionBubbleRef}
      data-testid={dataTestID}
    >
      <button
        data-testid={BillingCodesInfoBubbleTestID.QuestionIconButton}
        title="more info"
        className="rounded-full flex justify-center items-center cursor-pointer"
        style={{ outline: 'none', width: 14 }}
        onClick={() => {
          setShowPopover(!showPopover);
        }}
      >
        <IconQuestion
          className={classNames('fill-current hover:fill-current', {
            'text-gray-400': !warning,
            'hover:text-gray-600': !warning,
            'text-orange-500': warning,
            'hover:text-orange-600': warning,
          })}
        />
      </button>
      <BillingCodesInfoPopover
        dataTestID={BillingCodesInfoBubbleTestID.InfoPopover}
        popoverRef={popoverRef}
        visible={showPopover}
        onClose={() => {
          setShowPopover(false);
        }}
      />
    </div>
  );
};
